module.exports = __webpack_public_path__ + "static/img/BW.4198120e.svg";